import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { RecordOfCompletionDTO } from 'src/app/models/record-of-completion.model';
import { LearnerCertificateStatus, TPWorker } from 'src/app/models/worker.model';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { WorkerService } from 'src/app/services/worker-service/worker.service';
import { TrainingProgramApplicationUtils } from 'src/app/utils/training-program-application.util';
import { PageContentModel } from '../../models/page-content.model';
import { PageContentService } from '../../services/page-content/page-content.service';
import { Meta } from '@angular/platform-browser';

declare function getCurUrl(): string

@Component({
    selector: 'app-certificate-status',
    templateUrl: './certificate-status.component.html',
    providers: [PageContentService],
    styleUrls: ['./certificate-status.component.scss'],
    standalone: false
})
export class LearnerCertificateStatusComponent {
  tpAppUtils = TrainingProgramApplicationUtils
  sideBarContents: PageContentModel[];
  currentLang: string
  langCode;
  datePipe: DatePipe;
  workerId: string;
  programCode: string;
  learner: TPWorker;
  roc: RecordOfCompletionDTO;
  learnerCertificateStatus: LearnerCertificateStatus;
  learnerProfileWasMerged: boolean = false; //TO-DO

  constructor(private cdr: ChangeDetectorRef,
    public route: ActivatedRoute,
    public router: Router,
    public translateService: TranslateService,
    public pageContentService: PageContentService,
    private meta: Meta,
    @Inject('WorkerService') public workerService: WorkerService,
    @Inject('UtilsService') public utilsService: UtilsService) {
      this.currentLang = this.translateService.currentLang
      this.langCode = this.currentLang == 'en' ? 'en-CA' : 'fr-CA'
      this.datePipe = new DatePipe(this.langCode)
  }

  ngOnInit(): void {
    //Prevent this page from getting indexed by Google #143161
    this.meta.addTag({name: 'robots', content: 'noindex'})
    
    this.currentLang = this.translateService.currentLang
    this.translateService.onLangChange.subscribe(lang => this.currentLang = lang.lang);

    this.route.params.subscribe(p => {
      if (p['programCode'] && p['workerId']) {
        this.programCode = p['programCode'];
        this.workerId = p['workerId'];
        forkJoin({
          learnerCertificateStatus: this.workerService.GetLearnerCertificateDetails(this.workerId, this.programCode),
          sideBarContents: this.pageContentService.GetPageContentByPageName("WorkerProfileSidebar")
        }).subscribe(data => {
          this.learnerCertificateStatus = data.learnerCertificateStatus;
          this.sideBarContents = data.sideBarContents;
          if (this.learnerCertificateStatus) {
            this.learner = this.learnerCertificateStatus.Learner!;
            this.roc = this.learnerCertificateStatus.RecordOfCompletion!;
            this.learnerProfileWasMerged = !TrainingProgramApplicationUtils.isNullOrEmpty(this.learner.MergedBy) && !TrainingProgramApplicationUtils.isNullOrEmpty(this.learner.MergedOn) && !TrainingProgramApplicationUtils.isNullOrEmpty(this.learner.PreviousWorkerDisplayId);
          }
        }, err => console.log(err))
      }
    });
  }
}
